import { Component, OnInit } from '@angular/core';
import {  ListTableComponent  } from '@ppl/ui';
import { Router } from '@angular/router';
import { ClaimsService } from '../../../../services/claims.service';
import { SectionsService } from '../../../../services/sections.service';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-files-list',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './files-list.component.html',
  styleUrl: './files-list.component.css'
})
export class FilesListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_BILLING_FILES_DATA;
  pageId: string = PAGE_CONSTANTS.BILLING_FILES_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router,
    private sharedDataService: SharedDataService,
    private sectionService: SectionsService, private claimsService: ClaimsService, private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) {
  }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }
  rowClicked(rowDetail: any) {
    this.userService.setLeadEntry('batches');
    // this.sectionService.setFlow('processCode');
    // localStorage.setItem('selected_lead', rowDetail.processCodeDetailId);
    //   this.claimsService.fetchClaimsData(
    //       program.program_code,
    //       rowDetail.processCodeDetailId,
    //       'processCode'
    //     )
    //     .subscribe((data: any) => {
    //       this.claimsService.setFormData('process_code', data.responsedata);
    //       setTimeout(() => {
    //         this.router.navigate(['/home/processCode', 'update']);
    //       }, 200);
    //     });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }
}
